'use client'
import DOMPurify from 'dompurify'

export const sanitizerDescription = (description: string) => {
  return DOMPurify.sanitize(description || '')
}
